module.exports = __webpack_public_path__ + "img/0.17e2204a.jpg";